import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import type { NodeId } from '@ipfabric/utils';
import { performUndoableAction } from 'components/Graph/commands/history/performUndoableAction';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { makeUpdateNodesVisibility } from '../helpers/updateNodesVisibility';
import { selectPathLookupApplied } from '../model/selectors/graphMetadata/selectPathLookupApplied';

export interface HideNodeCommand {
  nodeId: NodeId;
}

export const hideNode: GraphCommandFactory<HideNodeCommand> =
  (cmdContext, dispatch) => (command) => {
    if (selectPathLookupApplied(cmdContext.getState())) {
      stumble('Hiding node is not allowed for Path-lookup');
      return;
    }

    const { peekingAtHiddenNodes } = cmdContext.getState();

    dispatch(performUndoableAction, {
      undo: makeUpdateNodesVisibility(
        cmdContext.updateState,
        [command.nodeId],
        true,
        peekingAtHiddenNodes,
      ),
      redo: makeUpdateNodesVisibility(
        cmdContext.updateState,
        [command.nodeId],
        false,
        peekingAtHiddenNodes,
      ),
    });
  };
